import React, { useEffect, useRef, useState } from "react";
import "../../css/Dashboard.scss";
import "../../css/Common.scss";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation, useNavigate } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Input } from "@progress/kendo-react-inputs";
import axios from "axios";
import { commonBaseUrl } from "../../../services/CommonUtil";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

type Row = {
  id: number;
  b2bServiceName: string;
  qty: string;
  amount: string;
};

type Errors = {
  [key: number]: {
    b2bServiceName?: string;
    qty?: string;
  };
};

interface B2BService {
  Id: number;
  B2BServiceName: String;
  B2BServiceDescription: String;
  B2BServicePicture: String;
  B2BServicePrice: number;
  IsActive: boolean;
  IsDelete: boolean;
  CreatedBy: number;
  CreatedOn: String;
  ModifiedBy: number;
  ModifiedOn: String;
}

interface B2BMaster {
  id: number;
  userId: number;
  bookingId: number;
  totalAmount: number;
  isActive: boolean;
  isDelete: boolean;
  createdBy: number;
  createdOn: string;
  modifiedBy: number;
  modifiedOn: string;
  userB2BServiceDetails: B2BMasterDetails;
}

interface B2BMasterDetails {
  id: number;
  userB2BServiceHeaderId: number;
  b2bServiceId: number;
  quantity: number;
  amount: number;
  isActive: boolean;
  isDelete: boolean;
  createdBy: number;
  createdOn: string;
  modifiedBy: number;
  modifiedOn: string;
}

export const CreateBusinessToBusiness = () => {
  const baseUrl = commonBaseUrl();
  const navigate = useNavigate();
  const locations = useLocation();

  const hasFetched = useRef(false);
  const [view, setView] = useState(false);
  const [usernameId, setUsernameId] = useState("");
  const [statusDialog, statusDialogSet] = useState(false);
  const [alertState, alertStateSet] = useState(false);
  const [alert, alertSet] = useState("");

  // Dropdown flow
  const [users, setUsers] = useState([]);
  const [selectUser, setSelectUser] = useState({ Id: 0, Name: "Select User" });
  const [bookingId, bookingIdSet] = useState();
  const [selectBookingId, setSelectBookingId] = useState({
    Id: 0,
    bookingId: "Select Booking Id",
  });
  const [selectBookingIds, setSelectBookingIds] = useState({
    Id: 0,
    BookingId: "Select Booking Id",
  });
  const [bookingIdEnabler, setBookingIdEnabler] = useState(false);
  const [detailsEnabler, setDetailsEnabler] = useState(false);
  const [loader, setLoader] = useState(false);
  const [b2bData, setB2BData] = useState<B2BService[]>([]);
  const [b2bServiceData, setB2BServiceData] = useState<B2BMaster[]>([]);
  const [defaultB2BValue, setDefaultB2BValue] = useState("");

  // Breadcrums
  const breadCrumbsData = [
    {
      id: "1",
      text: "Booking Management",
      route: "",
    },
    {
      id: "2",
      text: "B2B Services",
      route: "/management/b2bservice/b2bservicelist",
    },
    {
      id: "3",
      text: `${
        locations?.state.infoId === undefined
          ? "Create B2B Services"
          : "Edit B2B Services"
      }`,
      route: "",
    },
  ];

  // Handle dynamic row flow
  const [rows, setRows] = useState<Row[]>([
    {
      id: 1,
      b2bServiceName: "Select B2B Service",
      qty: "",
      amount: "",
    },
  ]);

  const [errors, setErrors] = useState<Errors>({});

  useEffect(() => {
    // Prevent second call
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (locations.state.infoId !== undefined) {
      setView(true);
      fetchB2BAPI();
    } else {
      fetchUsers(0);
      getB2BAPI(0);
    }
  }, []);

  const fetchB2BAPI = async () => {
    console.log(locations.state.infoId);
    try {
      const response = await axios.get(
        `${baseUrl}GetUserB2BServicesById?id=${locations.state.infoId}`
      );
      const b2bDetails = response.data.content;
      setB2BServiceData(b2bDetails);
      fetchUsers(b2bDetails);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchUsers = async (b2bDetails: any) => {
    try {
      const response = await axios.get(
        `${baseUrl}odata/Users?$filter=(IsActive eq true)and(RoleId eq 2)`
      );
      const usersData = response.data.value;
      console.log(locations.state.infoId);
      if (locations.state.infoId !== undefined) {
        const userJson = usersData.find(
          (item: any) => item.Id === b2bDetails[0].userId
        );
        console.log("userJson", userJson, b2bDetails[0].userId);
        setSelectUser(userJson);
        setUsernameId(userJson.CustomerId);
        fetchUserBooking(userJson.Id, b2bDetails[0]);
        setBookingIdEnabler(true);
        setDetailsEnabler(false);
      }
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchUserBooking = async (Id: any, b2bDetails: any) => {
    const bookingUrl =
      locations?.state.bookingStatus === "Completed"
        ? `${baseUrl}odata/Bookings?$filter=UserId eq ${Id}`
        : `${baseUrl}odata/Bookings?$filter=UserId eq ${Id} and BookingStatus eq 1`;
    try {
      const response = await axios.get(bookingUrl);
      const bookingData = response.data.value;
      bookingIdSet(bookingData);
      if (locations.state.infoId !== undefined) {
        const bookingJson = bookingData.find(
          (item: any) => item.Id === b2bDetails.bookingId
        );
        setSelectBookingIds(bookingJson);
        setDetailsEnabler(true);
        getB2BAPI(b2bDetails);
      }
    } catch (error) {
      console.error("Error fetching user booking data:", error);
    }
  };

  // Get Booking against order details
  const onChangeBooking = async (event: any) => {
    setDetailsEnabler(true);
    setSelectBookingIds(event.value);
  };

  const getB2BAPI = async (b2bDetails: any) => {
    try {
      const response = await axios.get(`${baseUrl}odata/B2BMasterServices`);
      setB2BData(response.data.value);
      if (locations.state.infoId !== undefined) {
        setDynamicRow(response.data.value, b2bDetails);
      } else {
        setDefaultB2BValue(response.data.value[0].B2BServiceName);
        setRows([
          {
            id: 1,
            b2bServiceName: response.data.value[0].B2BServiceName,
            qty: "",
            amount: "",
          },
        ]);
      }
    } catch (error) {
      console.error("Error fetching user booking data:", error);
    }
  };

  const setDynamicRow = (value: any, b2bDetails: any) => {
    const bulkOrders: any[] = [];
    const rowData = b2bDetails.userB2BServiceDetails;
    console.log("bulkOrders1", rowData);
    for (let c = 0; c < rowData.length; c++) {
      const b2bName = value.find(
        (item: any) => item.Id === rowData[c].b2bServiceId
      );
      const orderData = {
        id: c + 1,
        b2bServiceName: b2bName.B2BServiceName,
        qty: rowData[c].quantity,
        amount: rowData[c].amount,
      };
      bulkOrders.push(orderData);
    }
    console.log("bulkOrders2", bulkOrders);
    setRows(bulkOrders);
  };

  // Validation
  const handleSubmit = () => {
    if (handleValidation()) {
      if (locations.state.infoId !== undefined) {
        updateB2BService();
      } else {
        createB2BService();
      }
    } else {
      console.log("Validation failed", errors);
    }
  };

  // Save B2B
  const createB2BService = async () => {
    // setLoader(true);
    const bulkOrders: any[] = [];
    let totalAmount = 0;

    for (let c = 0; c < rows.length; c++) {
      const b2bId = b2bData.find(
        (item: any) => item.B2BServiceName === rows[c].b2bServiceName
      );
      const orderData = {
        Id: 0,
        UserB2BServiceHeaderId: 0,
        B2bServiceId: b2bId?.Id,
        Quantity: Number(rows[c].qty),
        Amount: Number(rows[c].amount),
        IsActive: true,
        IsDelete: true,
        CreatedBy: 0,
        CreatedOn: convertToISOFormat(new Date()),
        ModifiedBy: 0,
        ModifiedOn: convertToISOFormat(new Date()),
      };
      totalAmount += Number(rows[c].amount); // Accumulate total amount
      bulkOrders.push(orderData);
    }

    const fullOrders = {
      UserId: Number(selectUser.Id),
      BookingId: Number(selectBookingIds.Id),
      TotalAmount: Number(totalAmount),
      IsActive: true,
      IsDelete: true,
      CreatedBy: 0,
      CreatedOn: convertToISOFormat(new Date()),
      ModifiedBy: 0,
      ModifiedOn: convertToISOFormat(new Date()),
      UserB2BServiceDetails: bulkOrders,
    };
    console.log("response", fullOrders);

    try {
      const response = await axios.post(
        `${baseUrl}odata/UserB2BServiceHeaders`,
        fullOrders
      );
      statusDialogSet(true);
      setLoader(false);
      alertSet("B2B service created successfully");
    } catch (err) {
      console.log(err, "save");
      setLoader(false);
    }
  };

  // Update B2B
  const updateB2BService = async () => {
    // setLoader(true);
    const bulkOrders: any[] = [];
    let totalAmount = 0;
    console.log("locations", locations.state.infoId);
    for (let c = 0; c < rows.length; c++) {
      const b2bId = b2bData.find(
        (item: any) => item.B2BServiceName === rows[c].b2bServiceName
      );
      const orderData = {
        Id: 0,
        UserB2BServiceHeaderId: Number(b2bServiceData[0].id),
        B2bServiceId: b2bId?.Id,
        Quantity: Number(rows[c].qty),
        Amount: Number(rows[c].amount),
        IsActive: true,
        IsDelete: true,
        CreatedBy: 0,
        CreatedOn: convertToISOFormat(new Date()),
        ModifiedBy: 0,
        ModifiedOn: convertToISOFormat(new Date()),
      };
      totalAmount += Number(rows[c].amount); // Accumulate total amount
      bulkOrders.push(orderData);
    }

    const fullOrders = {
      Id: Number(b2bServiceData[0].id),
      UserId: Number(b2bServiceData[0].userId),
      BookingId: Number(b2bServiceData[0].bookingId),
      TotalAmount: Number(totalAmount),
      IsActive: true,
      IsDelete: true,
      CreatedBy: 0,
      CreatedOn: convertToISOFormat(new Date()),
      ModifiedBy: 0,
      ModifiedOn: convertToISOFormat(new Date()),
      UserB2BServiceDetails: bulkOrders,
    };
    console.log("response", fullOrders);

    try {
      const response = await axios.post(
        `${baseUrl}odata/UpdateUserB2BServiceHeader?key=${Number(
          b2bServiceData[0].id
        )}`,
        fullOrders
      );
      statusDialogSet(true);
      setLoader(false);
      alertSet("B2B service updated successfully");
    } catch (err) {
      console.log(err, "save");
      setLoader(false);
    }
  };

  // Date & Time conversion
  const convertToISOFormat = (inputDate: any): string => {
    // Parse the input date string to a Date object
    const dateObj = new Date(inputDate);

    // Extract the individual date components
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    // Get the timezone offset in hours and minutes
    const timezoneOffset = -dateObj.getTimezoneOffset(); // In minutes
    const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(
      2,
      "0"
    );
    const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(
      2,
      "0"
    );

    // Construct the ISO 8601 formatted string with timezone
    const isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+${offsetHours}:${offsetMinutes}`;

    return isoFormattedDate;
  };

  // Back to B2B list
  const navigateBack = () => {
    if (alertState === false) {
      navigate("/management/b2bservice/b2bservicelist");
      window.scrollTo(0, 0);
    }
    alertStateSet(false);
    statusDialogSet(false);
  };

  // Handle dynamic row flow
  const handleAddRow = () => {
    console.log("Rows->", rows);
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        b2bServiceName: defaultB2BValue,
        qty: "",
        amount: "",
      },
    ]);
  };

  const [cancel, cancelSet] = useState(false);
  const [deleteGuestId, setDeleteGuestId] = useState(0);

  const handleDeleteRow = (id: number, confirmDelete: any) => {
    cancelSet(confirmDelete);
    setDeleteGuestId(confirmDelete === false ? 0 : id);
    if (confirmDelete === false) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const handleInputChange = (id: number, field: keyof Row, value: string) => {
    let updatedRows: Row[] = [...rows]; // Ensure it's always an array

    if (field === "b2bServiceName") {
      updatedRows = rows.map((row) => {
        if (row.id === id) {
          const selectedService = b2bData.find(
            (service) => service.B2BServiceName === value
          );
          const quantity = parseInt(row.qty) || 0;
          const updatedAmount = selectedService
            ? String(selectedService.B2BServicePrice * quantity)
            : "0";
          return { ...row, b2bServiceName: value, amount: updatedAmount };
        }
        return row;
      });
    } else if (/^\d*$/.test(value)) {
      updatedRows = rows.map((row) => {
        if (row.id === id) {
          const selectedService = b2bData.find(
            (service) => service.B2BServiceName === row.b2bServiceName
          );
          const quantity =
            field === "qty" ? parseInt(value) || 0 : parseInt(row.qty) || 0;
          const updatedAmount = selectedService
            ? String(selectedService.B2BServicePrice * quantity)
            : "0";
          return { ...row, [field]: value, amount: updatedAmount };
        }
        return row;
      });
    }

    // Safely update the rows state
    if (updatedRows) {
      setRows(updatedRows);
    }
  };

  const validateRow = (row: Row) => {
    const newErrors: Errors[typeof row.id] = {};

    if (row.b2bServiceName === "Select B2B Service") {
      newErrors.b2bServiceName = "Please select a service.";
    }

    if (
      rows.some(
        (r) => r.id !== row.id && r.b2bServiceName === row.b2bServiceName
      )
    ) {
      newErrors.b2bServiceName = "This service is already selected.";
    }

    if (!row.qty || Number(row.qty) <= 0) {
      newErrors.qty = "Please enter a valid quantity.";
    } else if (!/^\d+$/.test(row.qty)) {
      newErrors.qty = "Quantity must be an integer.";
    } else if (Number(row.qty) > 999) {
      newErrors.qty = "Maximum quantity is 999.";
    }

    return newErrors;
  };

  const handleValidation = () => {
    const allErrors: Errors = {};
    rows.forEach((row) => {
      const rowErrors = validateRow(row);
      if (Object.keys(rowErrors).length > 0) {
        allErrors[row.id] = rowErrors;
      }
    });
    setErrors(allErrors);
    return Object.keys(allErrors).length === 0;
  };

  const preventDotInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "." || event.key === "e") {
      event.preventDefault();
    }
  };

  return (
    <div className="dashboard-bg" style={{ padding: "10px" }}>
      {loader === true ? (
        <div className="loader">
          <Loader size="large" type={"converging-spinner"} />
        </div>
      ) : (
        <div>
          <div className="overall-view">
            <div>
              <div className="dashboard-button">
                <Breadcrumbs breadCrumbData={breadCrumbsData} />
              </div>
              <hr className="hr-border" />
            </div>
          </div>
          <div className="overall-view">
            {/* Detail Screen*/}
            <div className="form-row-create">
              <div className="form-group">
                <Label>User Name</Label>
                <DropDownList
                  className="book-dropdown-new"
                  data={users}
                  disabled={view}
                  textField="Name"
                  value={selectUser}
                  onChange={(event) => {
                    bookingIdSet(undefined);
                    setSelectBookingId({
                      Id: 0,
                      bookingId: "Select Booking Id",
                    });
                    setSelectUser(event.value);
                    setUsernameId(event.value.CustomerId);
                    fetchUserBooking(event.value.Id, 0);
                    setBookingIdEnabler(true);
                    setDetailsEnabler(false);
                  }}
                  name="Name"
                />
              </div>
              {bookingIdEnabler === true ? (
                <div
                  className="form-group"
                  style={{ padding: "0px 10px 0px 0px" }}
                >
                  <Label>Customer ID</Label>
                  {selectBookingId.bookingId !== undefined ? (
                    <div>
                      <Input
                        type="text"
                        className="book-dropdown-new"
                        placeholder=""
                        disabled={true}
                        value={usernameId}
                      />
                    </div>
                  ) : (
                    <DropDownList
                      className="book-dropdown-new"
                      data={bookingId}
                      disabled={view}
                      textField="BookingId"
                      value={selectBookingId}
                      name="bookingID"
                    />
                  )}
                </div>
              ) : (
                <div className="form-group"></div>
              )}
              {bookingIdEnabler === true ? (
                <div
                  className="form-group"
                  style={{ padding: "0px 10px 0px 0px" }}
                >
                  <Label>Booking ID</Label>
                  {selectBookingId.bookingId !== undefined ? (
                    <div>
                      <DropDownList
                        className="book-dropdown-new"
                        data={bookingId}
                        disabled={view}
                        textField="BookingId"
                        dataItemKey="Id"
                        value={selectBookingIds}
                        onChange={(event) => onChangeBooking(event)}
                        name="bookingId"
                      />
                    </div>
                  ) : (
                    <DropDownList
                      className="book-dropdown-new"
                      data={bookingId}
                      textField="BookingId"
                      dataItemKey="Id"
                      value={selectBookingId}
                      onChange={(event) => onChangeBooking(event)}
                      name="bookingID"
                    />
                  )}
                </div>
              ) : (
                <div className="form-group"></div>
              )}
            </div>
            {/* Dynamic row */}
            <div>
              {detailsEnabler === true ? (
                <div>
                  <div>
                    <Label
                      style={{
                        marginLeft: "10px",
                        fontSize: "20px",
                        fontWeight: "normal",
                      }}
                    >
                      B2B Data
                    </Label>
                    {rows.map((row, index) => (
                      <div
                        className="form-row-create"
                        style={{ flexWrap: "unset", marginBottom: "10px" }}
                        key={row.id}
                      >
                        <div className="form-group">
                          <Label>B2B Service</Label>
                          <DropDownList
                            className="book-dropdown-new"
                            data={b2bData}
                            dataItemKey="Id"
                            textField="B2BServiceName"
                            disabled={
                              locations?.state.bookingStatus === "Completed"
                                ? true
                                : false
                            }
                            name="b2bServiceName"
                            value={b2bData.find(
                              (item: any) =>
                                item.B2BServiceName === row.b2bServiceName
                            )}
                            onChange={(event) =>
                              handleInputChange(
                                row.id,
                                "b2bServiceName",
                                event.value.B2BServiceName
                              )
                            }
                          />
                          {index > 0 && errors[row.id]?.b2bServiceName && (
                            <span style={{ color: "red" }} className="error">
                              {errors[row.id].b2bServiceName}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <Label>Qty</Label>
                          <Input
                            type="number"
                            name="qty"
                            className="book-dropdown-new"
                            placeholder="Enter Qty"
                            disabled={
                              locations?.state.bookingStatus === "Completed"
                                ? true
                                : false
                            }
                            value={row.qty}
                            onKeyDown={preventDotInput} // Prevent dot key input
                            maxLength={3}
                            onChange={(e) =>
                              handleInputChange(row.id, "qty", e.value)
                            }
                          />
                          {errors[row.id]?.qty && (
                            <span style={{ color: "red" }} className="error">
                              {errors[row.id].qty}
                            </span>
                          )}
                        </div>

                        <div className="form-group">
                          <Label>Amount</Label>
                          <Input
                            type="number"
                            name="amount"
                            className="book-dropdown-new"
                            placeholder="Enter Amount"
                            value={row.amount}
                            readOnly
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          {index > 0 && <Label>Action</Label>}
                          {index > 0 && (
                            <Button
                              className="button-view"
                              style={{ marginLeft: "0px" }}
                              onClick={() => handleDeleteRow(row.id, true)}
                            >
                              Delete
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                    {b2bData.length >= rows.length + 1 && (
                      <Button
                        className="button-view"
                        style={{ marginLeft: "12px" }}
                        onClick={handleAddRow}
                      >
                        Add More
                      </Button>
                    )}
                  </div>

                  <div className="form-row-create">
                    <div className="form-group" style={{}}></div>
                  </div>
                  <div style={{ padding: "20px" }}>
                    <div
                      className="center-view"
                      style={{
                        paddingBottom: "50px",
                      }}
                    >
                      <div className="form-row-area">
                        <div className="form-group-area"></div>
                      </div>
                      <div className="button-group">
                        {/* {view === true ? (
                          <div></div>
                        ) : ( */}
                        {locations.state.infoId !== undefined &&
                          locations?.state.bookingStatus !== "Completed" && (
                            <Button
                              className="button-view"
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              {"UPDATE"}
                            </Button>
                          )}
                        {locations.state.infoId === undefined &&
                          locations?.state.bookingStatus === "" && (
                            <Button
                              className="button-view"
                              onClick={() => {
                                handleSubmit();
                              }}
                            >
                              {"CREATE"}
                            </Button>
                          )}
                        {/* )} */}
                        <Button
                          // type="submit"
                          className="common-button-view"
                          onClick={() => {
                            navigate("/management/b2bservice/b2bservicelist");
                          }}
                        >
                          CANCEL
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
            {statusDialog && (
              <Dialog>
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <h3>{alert}</h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: "30px",
                    }}
                  >
                    <Button
                      className="button-view"
                      onClick={() => navigateBack()}
                    >
                      Ok
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
            {cancel && (
              <Dialog title={"Confirm Delete"} onClose={() => cancelSet(false)}>
                <p style={{ margin: "25px", textAlign: "center" }}>
                  Are you sure want to delete this B2B service detail?
                </p>
                <DialogActionsBar>
                  <Button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      cancelSet(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDeleteRow(deleteGuestId, false);
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActionsBar>
              </Dialog>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
